(() => {
  const dialog=document.querySelector('[data-kw]');
  if(!dialog || dialog.dataset.initialized || dialog.dataset.enabled!=='true')return;
  dialog.dataset.initialized='true';
  const $=s=>dialog.querySelector(s),buttons=[...dialog.querySelectorAll('[data-choice]')];
  const status=$('.kw-status'),login=$('.kw-login'),claim=$('.kw-claim');
  const text=JSON.parse(document.querySelector('[data-kw-strings]').textContent);
  const authenticated=dialog.dataset.customer==='true';
  if(dialog.dataset.used==='true')return;
  const get=(store,key)=>{try{return store.getItem(key);}catch{return null;}};
  const put=(store,key,value)=>{try{store.setItem(key,value);}catch{}};
  const remove=(store,key)=>{try{store.removeItem(key);}catch{}};
  let selected=get(sessionStorage,'kw-native-choice'),priorFocus,oldOverflow;
  if(!['discount','engraving'].includes(selected))selected=null;
  const returning=get(sessionStorage,'kw-native-return')==='1';
  const sync=()=>buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.choice===selected)));
  sync();
  buttons.forEach(b=>b.addEventListener('click',()=>{selected=b.dataset.choice;put(sessionStorage,'kw-native-choice',selected);sync();status.textContent='';}));
  login.hidden=authenticated;claim.hidden=!authenticated;
  login.addEventListener('click',event=>{
    if(!selected){event.preventDefault();status.textContent=text.choose_first;buttons[0].focus();return;}
    put(sessionStorage,'kw-native-return','1');
  });
  claim.addEventListener('click',()=>{
    if(!selected){status.textContent=text.choose_first;buttons[0].focus();return;}
    const code=selected==='discount'?dialog.dataset.discountCode:dialog.dataset.engravingCode;
    if(!code){status.textContent=text.unavailable;return;}
    claim.disabled=true;
    remove(sessionStorage,'kw-native-return');
    const destination=selected==='engraving'?'/collections/all':'/cart';
    location.assign('/discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent(destination));
  });
  $('.kw-close').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('close',()=>{document.documentElement.style.overflow=oldOverflow;put(localStorage,'koville-welcome-dismissed-v1',String(Date.now()));remove(sessionStorage,'kw-native-return');priorFocus?.focus();});
  function open(){
    if(!returning && Date.now()-Number(get(localStorage,'koville-welcome-dismissed-v1')||0)<Number(dialog.dataset.cooldown||7)*86400000)return;
    if(location.pathname.includes('/account'))return;
    priorFocus=document.activeElement;oldOverflow=document.documentElement.style.overflow;
    dialog.dataset.revealed='true';$('.kw-paper').inert=false;status.textContent='';
    dialog.showModal();document.documentElement.style.overflow='hidden';
    if(returning && authenticated)buttons.find(b=>b.dataset.choice===selected)?.focus();
  }
  setTimeout(open,returning?0:Number(dialog.dataset.delay||3)*1000);
})();

